<template>
	<div>
		<div v-if="expenses.mode == null" class="w-full mr-2">
			<div v-if="expenseList.length" class="flex flex-col">
	        	<table class="w-full">
	        		<thead>
	        			<tr>
		                    <th class="pl-4">Type</th>
		        			<th class="text-right pr-8">Amount</th>
		        			<th>Frequency</th>
		        			<th class="text-right">PSF</th>
		        			<th></th>
		        		</tr>
	        		</thead>
	        		<tbody>
	        			<tr v-for="expense in expenseList" :key="expense.id">
	                        <td class="pl-4">{{ expense.type.name }}</td>
	        				<td class="text-right pr-8">{{ formatCurrency(expense.amount, expense.frequency == 'PSF' ? 2 : 0) }}</td>
	        				<td>{{ expense.frequency }}</td>
	        				<td class="text-right">{{ formatCurrency(expense.amount_psf, 2) }}</td>
	        				<td class="flex justify-center space-x-3">
					            <button @click="editExpense(expense.id)" type="button" class="btn btn-action">Edit</button>
					            <button @click="confirmDeleteExpense(expense.id)" type="button" class="btn btn-action">Delete</button>
	        				</td>
						</tr>
					</tbody>
				</table>
				<button 
				    v-if="expenseList.length && canCreateExpense" 
				    @click="createExpense" 
				    type="button" 
				    class="my-3 max-w-fit flex items-center self-end btn btn-small btn-indigo">
					<inline-svg name="add-white"></inline-svg>
					<span>Create Expense</span>
				</button>
			</div>
            <div v-else class="flex flex-col h-full items-center justify-center space-y-2">
                <span class="text-xl">No Expenses Found</span>
                <button 
                    v-if="canCreateExpense"
                    type="button"
                    @click.prevent="createExpense"
                    class="flex items-center btn btn-small btn-indigo">
                        <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                        <span class="ml-2">New Expense</span>
                </button>
            </div>
		</div>

		<div v-else>
			<div>
	            <form>
	                <div class="p-2 mr-2">
	                    <div class="flex">
		                    <div class="flex flex-1 flex-col shadow-md rounded mr-6 p-6 bg-gray-100 border border-gray-200">
		                        <div class="mb-4 flex gap-4">
		                            <div>
		                                <label for="type">Type</label>
		                                <select v-model="selectedExpense.type_id" class="mt-1 form-select min-w-fit">
		                                	<option value=""></option>
		                                	<option v-for="type in expenses.expenseTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
		                                </select>
		                                <div v-if="errors.type_id" class="form-error">{{ errors.type_id[0] }}</div>
		                            </div>
			                        <div>
										<label for="frequency">Frequency</label>
			                        	<select v-model="selectedExpense.frequency" class="mt-1 form-select">
			                        		<option value=""></option>
			                        		<option value="PSF">PSF</option>
			                        		<option value="Monthly">Monthly</option>
			                        		<option value="Quarterly">Quarterly</option>
			                        		<option value="Annual">Annual</option>
			                        		<option value="Semi-Annual">Semi-Annual</option>
			                        		<option value="One Time">One Time</option>
			                        	</select>
			                        	<div v-if="errors.frequency" class="form-error">{{ errors.frequency[0] }}</div>
			                        </div>
			                        <div>
										<label for="expense_amount">Amount</label>
										<currency-input v-model="selectedExpense.amount_in_dollars" :size="11" name='expense_amount' is-decimal></currency-input>
										<div v-if="errors.amount" class="form-error">{{ errors.amount[0] }}</div>
			                        </div>								
								</div>
		                        <div>
		                            <textarea v-model="selectedExpense.note" class="form-textarea text-sm w-full" cols="7" rows="5" name="note" placeholder="Expense Notes"></textarea>
		                        </div>
		                    </div>
						</div>
	                </div>
	            </form>
	        </div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters } from 'vuex'
	import moment from 'moment';

	export default {
        components: {
        },
        
		data() {
			return {
				errors: {},

                valueType: {
                    value2date: (value) => {
                        return value ? moment(value, 'YYYY-MM-DD').toDate() : null
                    },
                    date2value: (date) => {
                        return date ? moment(date).format('YYYY-MM-DD') : null
                    }
                }        
			}
		},

		created() {
			this.$store.dispatch('loadExpenseTypes');
		},

		computed: {
			...mapState(['units']),
			...mapState(['expenses']),
			...mapGetters(['selectedUnit']),
			canCreateExpense() {
			    return this.$gate.can('create', 'site');
			},
			...mapGetters(['selectedExpense']),

			expenseList() {
				return this.expenses.all;
			}
		},

		methods: {       
			createExpense() {
				this.$store.dispatch('createExpense', {
					expensableId: this.units.selectedUnitId,
					expensableType: 'App\\Unit'
				})
			},

			editExpense(expenseId) {
				this.expenses.mode = 'editing';
				this.expenses.selectedExpenseId = expenseId;
			},

	        confirmDeleteExpense(expenseId) {
	            if (expenseId == "new") {
	                this.$store.dispatch('removeExpense', 'new');
	                
	                return;
	            }

	            this.$swal({
	                title: 'Are you sure?',
	                text: "Are you sure you want to delete this Expense?",
	                type: 'warning',
	                buttonsStyling: false,
	                confirmButtonText: 'Yes - Delete it',
	                confirmButtonClass: 'btn btn-red',
	                showCancelButton: true,
	                cancelButtonClass: 'btn btn-secondary mr-4',
	                reverseButtons: true
	            }).then(async (result) => {
	                if (result.value) {
	                     await this.$store.dispatch('deleteExpense', expenseId).then(() => {
		                    this.$notify({
		                        type: 'success',
		                        title: 'Success',
		                        text: 'Expense Deleted'
		                    });
	                     });
	                }
	            });
	        },
		},
	}
</script>